import * as React from "react";
const SvgSparkles = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M35 33v4zm-2 2h4zm3 12v4zm-2 2h4zm9-16 2.286 6.857L51 42l-5.714 2.143L43 51l-2.286-6.857L35 42l5.714-2.143z"
    />
  </svg>
);
export default SvgSparkles;
